var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-btn",
        {
          staticClass: "btn",
          on: {
            click: function($event) {
              return _vm.handleClick()
            }
          }
        },
        [
          _c("v-icon", { staticClass: "icon", attrs: { dark: "", left: "" } }, [
            _vm._v("add_circle_outline")
          ]),
          _c("span", { staticClass: "text" }, [_vm._v("Crear Solicitud")])
        ],
        1
      ),
      _c("CrearSolicitudModal", {
        attrs: { show: _vm.mostrarModalCrear },
        on: { cerrar: _vm.handleCierreModalCrear }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }